function openPopUpEasyCheckout(
    product,
    tag,
    material,
    variants,
    tableTallas,
    corte,
    recomendationTable,
    tablaMedidas,
    preselectedColor = null,
    preselectedSize = null,
    tipoMaterial,
) {
    const overlay = document.querySelector(".cart-notification-overlay");
    const easyCheckout = document.querySelector(".easy-checkout");
    const titleElement = document.getElementById("easy-checkout-title");
    const imageElement = document.getElementById("easy-checkout-image");
    const linkElement = document.getElementById("easy-checkout-image-link");
    const linkElementTitle = document.getElementById(
        "easy-checkout-title-link",
    );
    const tagElement = document.getElementById("easy-checkout-product-tag");
    const materialElement = document.getElementById("easy-checkout-material");
    const priceElement = document.getElementById("easy-checkout-price");
    const comparePriceElement = document.getElementById(
        "easy-checkout-compare",
    );
    const containerForm = document.getElementById("product-container");

    // Limpiar formulario previo
    while (containerForm.firstChild)
        containerForm.removeChild(containerForm.firstChild);

    const form = renderProductForm(
        product,
        variants,
        imageElement,
        material,
        tableTallas,
        corte,
        recomendationTable,
        tablaMedidas,
        linkElement,
        linkElementTitle,
        preselectedColor,
        preselectedSize,
        tipoMaterial,
    );

    containerForm.appendChild(form);

    // 🔥 Setear imagen inicial del producto
    const firstAvailableVariant = product.variants.find((v) => v.available);

    if (firstAvailableVariant?.featured_image) {
        imageElement.style.backgroundImage = `url(https:${firstAvailableVariant.featured_image.src})`;

        linkElement.href = `/products/${product.handle}/?variant=${firstAvailableVariant.id}`;
        linkElementTitle.href = `/products/${product.handle}/?variant=${firstAvailableVariant.id}`;
    }
    // fallback si no hay imagen en variante
    else if (product.featured_image) {
        imageElement.style.backgroundImage = `url(https:${product.featured_image})`;
        linkElement.href = `/products/${product.handle}`;
        linkElementTitle.href = `/products/${product.handle}`;
    }

    titleElement.textContent = product.title;
    tagElement.textContent = tag;
    materialElement.textContent = material;
    priceElement.textContent = `$${(product.price / 100).toFixed(2)}`;
    if (product.compare_at_price > product.price) {
        comparePriceElement.textContent = `$${(
            product.compare_at_price / 100
        ).toFixed(2)}`;
    }

    easyCheckout.classList.add("active");
    overlay.classList.add("active");
}

function closePopUpEasyCheckout() {
    let overlay = document.querySelector(".cart-notification-overlay");
    let easyCheckout = document.querySelector(".easy-checkout");
    easyCheckout.classList.remove("active");
    overlay.classList.remove("active");
}

function handleOpenPopUpEasyCheckout(button) {
    const productData = JSON.parse(button.getAttribute("data-product"));
    const tag = button.getAttribute("data-tag");
    const material = button.getAttribute("data-material");
    const variantsArray = button.getAttribute("data-options");
    const tableTallas = button.getAttribute("data-table-tallas");
    const corte = button.getAttribute("data-corte");
    const recomendationTable = button.getAttribute("data-recomendations");
    const tablaMedidas = button.getAttribute("data-medidas");
    const preselectedColor = button.getAttribute("data-selected-color");
    const preselectedSize = button.getAttribute("data-selected-size");
    const tipoMaterial = button.getAttribute("data-tipo");
    openPopUpEasyCheckout(
        productData,
        tag,
        material,
        variantsArray,
        tableTallas,
        corte,
        recomendationTable,
        tablaMedidas,
        preselectedColor,
        preselectedSize,
        tipoMaterial,
    );
}

function renderProductForm(
    product,
    variants,
    imageElement,
    material,
    tableTallas,
    corte,
    recomendationTable,
    tablaMedidas,
    linkElement,
    linkElementTitle,
    preselectedColor,
    preselectedSize,
    tipoMaterial,
) {
    const sizeButtonsMap = {};
    const availableVariants = product.variants.filter((v) => v.available);

    const options = JSON.parse(variants);
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/cart/add";
    form.innerHTML = `
    <input type="hidden" name="form_type" value="product">
    <input type="hidden" name="utf8" value="✓">
  `;

    let selectedOptions = { Color: null, Size: null };
    const variantIdInput = document.createElement("input");
    variantIdInput.type = "hidden";
    variantIdInput.name = "id";
    form.appendChild(variantIdInput);

    function updateAvailableSizesForColor(color) {
        Object.entries(sizeButtonsMap).forEach(([size, button]) => {
            const exists = product.variants.some(
                (v) => v.available && v.option1 === color && v.option2 === size,
            );
            button.disabled = !exists;
            button.classList.toggle("disabled", !exists);

            if (!exists && selectedOptions.Size === size) {
                button.classList.remove("selected");
                selectedOptions.Size = null;
                updateVariantId();
            }
        });
    }

    function updateVariantId() {
        const variant = product.variants.find(
            (v) =>
                v.option1 === selectedOptions.Color &&
                v.option2 === selectedOptions.Size,
        );

        const optionNames = options.map((opt) => opt.name.toLowerCase());
        const hasColorOption = optionNames.includes("color");
        const hasSizeOption =
            optionNames.includes("size") ||
            optionNames.includes("talla") ||
            optionNames.includes("tamaño");

        let missingMessage = "";
        const hasColor = !!selectedOptions.Color;
        const hasSize = !!selectedOptions.Size;

        if (!hasColor && !hasSize) {
            if (hasColorOption && hasSizeOption)
                missingMessage = "Selecciona color y talla";
            else if (hasColorOption) missingMessage = "Selecciona un color";
            else if (hasSizeOption) missingMessage = "Selecciona una talla";
        } else if (!hasColor && hasColorOption) {
            missingMessage = "Selecciona un color";
        } else if (!hasSize && hasSizeOption) {
            missingMessage = "Selecciona una talla";
        }

        if (variant) {
            variantIdInput.value = variant.id;
            buttonAddToCart.disabled = false;
            buttonAddToCart.textContent = "Agregar al carrito";
        } else {
            variantIdInput.value = "";
            buttonAddToCart.disabled = true;
            buttonAddToCart.textContent = missingMessage;
            console.warn("No se encontró variante con esta combinación.");
        }
    }

    let materialAdded = false;
    options.forEach((option) => {
        let optionName = option.name.toUpperCase();

        let mainDivOption = document.createElement("div");
        mainDivOption.classList.add("product-option");

        let divOption = document.createElement("div");
        divOption.classList.add("select-variant");
        mainDivOption.appendChild(divOption);

        let divHeader = document.createElement("div");
        divHeader.classList.add("select-variant-header");
        divOption.appendChild(divHeader);

        let optionTitle = document.createElement("h3");
        let displayName = optionName;
        if (["COLOR"].includes(optionName)) displayName = "Color";
        else if (["SIZE", "TALLA", "TAMAÑO"].includes(optionName))
            displayName = "Talla";

        optionTitle.innerText = displayName;
        divHeader.appendChild(optionTitle);

        let optionDescription = document.createElement("span");
        optionDescription.classList.add("option-description");
        optionDescription.innerText = "Elige tu favorito";
        divHeader.appendChild(optionDescription);

        let optionValues = document.createElement("div");
        optionValues.classList.add("option-values");
        divOption.appendChild(optionValues);

        // if (!materialAdded && tipoMaterial) {
        //     const materialDiv = document.createElement("div");
        //     materialDiv.classList.add("tipo-material");
        //     materialDiv.innerHTML = `<h3>Material</h3> <p>${tipoMaterial}</p>`;
        //     mainDivOption.insertBefore(materialDiv, divOption);
        //     materialAdded = true;
        // }

        if (optionName === "COLOR") {
            const colorWrapper = document.createElement("div");
            colorWrapper.classList.add("color-wrapper");

            const colorOptionsContainer = document.createElement("div");
            colorOptionsContainer.classList.add("color-options");

            const bulletsContainer = document.createElement("div");
            bulletsContainer.classList.add("product-form__input-bullets");

            // 👉 Crear bullets dinámicamente

            if (tablaMedidas) {
                const btnMedidas = document.createElement("button");
                btnMedidas.classList.add("sizes-btn");
                btnMedidas.type = "button";
                btnMedidas.dataset.productTitle = product.title;
                btnMedidas.dataset.medidas = tablaMedidas;
                btnMedidas.onclick = () =>
                    handleOpenPopUpGuiaMedidas(btnMedidas);

                btnMedidas.innerHTML = `
            <img src="https://cdn.shopify.com/s/files/1/3004/6046/files/Vector.svg?v=1749146880" alt="Icono de talla">
            <span>Tabla medidas</span>
        `;

                bulletsContainer.appendChild(btnMedidas);
            }

            if (tipoMaterial) {
                const btnMaterial = document.createElement("button");
                btnMaterial.classList.add("sizes-btn");
                btnMaterial.type = "button";
                btnMaterial.dataset.productMaterial = tipoMaterial;
                btnMaterial.onclick = () =>
                    handleOpenPopUpMaterial(btnMaterial);

                btnMaterial.innerHTML = `
            <img src="https://cdn.shopify.com/s/files/1/3004/6046/files/ICONOS_00902ffb-c0ae-4fee-b6e1-87b1e4bebc0a.png?v=1769460199" alt="Icono de material">
            <span>${tipoMaterial}</span>
        `;

                bulletsContainer.appendChild(btnMaterial);
            }

            const btnHandmade = document.createElement("button");
            btnHandmade.classList.add("sizes-btn");
            btnHandmade.type = "button";

            btnHandmade.innerHTML = `
        <img src="https://cdn.shopify.com/s/files/1/3004/6046/files/mano.png?v=1769804127" alt="Hecho a mano">
        <span>Hecho a mano en México</span>
    `;

            bulletsContainer.appendChild(btnHandmade);
            option.values.forEach((color) => {
                const variantForColor = product.variants.find(
                    (v) => v.option1 === color && v.featured_image,
                );

                const imageUrl = variantForColor?.featured_image
                    ? `https:${variantForColor.featured_image.src}`
                    : null;

                const divColor = document.createElement("div");
                divColor.classList.add("color-variant-container");

                const button = document.createElement("button");
                button.classList.add("color-image-button");
                button.type = "button";
                button.dataset.color = color;
                button.title = color;

                if (imageUrl) {
                    const img = document.createElement("img");
                    img.src = imageUrl;
                    img.alt = color;
                    img.classList.add("color-variant-image");
                    button.appendChild(img);
                }

                const label = document.createElement("span");
                label.classList.add("color-variant-label");
                label.textContent = color;

                const isColorAvailable = availableVariants.some(
                    (v) => v.option1 === color,
                );

                if (!isColorAvailable) {
                    button.disabled = true;
                    button.classList.add("disabled");
                    label.classList.add("disabled");
                }

                button.addEventListener("click", () => {
                    document
                        .querySelectorAll(".color-variant-container")
                        .forEach((container) =>
                            container.classList.remove("selected"),
                        );

                    divColor.classList.add("selected");

                    selectedOptions.Color = color;

                    if (variantForColor) {
                        imageElement.style.backgroundImage = `url(${imageUrl})`;
                        linkElement.href = `/products/${product.handle}/?variant=${variantForColor.id}`;
                        linkElementTitle.href = `/products/${product.handle}/?variant=${variantForColor.id}`;
                    }

                    updateVariantId();
                    updateAvailableSizesForColor(color);
                });

                divColor.appendChild(button);
                divColor.appendChild(label);
                optionValues.appendChild(divColor);

                colorOptionsContainer.appendChild(divColor);
            });

            colorWrapper.appendChild(colorOptionsContainer);
            colorWrapper.appendChild(bulletsContainer);

            optionValues.appendChild(colorWrapper);
        } else if (optionName === "SIZE" || optionName === "TALLA") {
            const divSizeOption = document.createElement("div");
            divSizeOption.classList.add("size-option");
            optionValues.appendChild(divSizeOption);

            const divSizeOptionContainer = document.createElement("div");
            divSizeOptionContainer.classList.add("size-option-container");
            divSizeOption.appendChild(divSizeOptionContainer);

            option.values.forEach((size) => {
                const isSizeAvailable = availableVariants.some(
                    (v) => v.option2 === size,
                );
                const button = document.createElement("button");
                button.classList.add("size-button");
                button.type = "button";
                button.dataset.size = size;
                button.innerText = size;

                sizeButtonsMap[size] = button;

                if (!isSizeAvailable) {
                    button.disabled = true;
                    button.classList.add("disabled");
                }

                button.addEventListener("click", () => {
                    document
                        .querySelectorAll(".size-button")
                        .forEach((btn) => btn.classList.remove("selected"));
                    button.classList.add("selected");
                    selectedOptions.Size = size;
                    optionDescription.innerText = "Elige tu medida ideal";
                    updateVariantId();
                });

                divSizeOptionContainer.appendChild(button);
            });

            const guideButton = document.createElement("button");
            guideButton.classList.add("sizes-btn");
            guideButton.id = "sizes_btn";
            guideButton.type = "button";
            guideButton.dataset.product = JSON.stringify(product);
            guideButton.dataset.material = material;
            guideButton.dataset.tableTallas = tableTallas;
            guideButton.dataset.corte = corte;
            guideButton.dataset.recomendations = recomendationTable;
            guideButton.onclick = () => handleOpenPopUpGuiaTallas(guideButton);

            const img = document.createElement("img");
            img.src =
                "https://cdn.shopify.com/s/files/1/3004/6046/files/Vector.svg?v=1749146880";
            img.alt = "Icono de talla";
            guideButton.appendChild(img);

            const span = document.createElement("span");
            span.textContent = "Guía de tallas";
            guideButton.appendChild(span);
            divSizeOption.appendChild(guideButton);

            const buttonRecomendation = document.createElement("button");
            buttonRecomendation.type = "button";
            buttonRecomendation.classList.add("size-recommendation-button");
            buttonRecomendation.id = "size-recommendation-button";
            buttonRecomendation.onclick = () =>
                handleOpenPopUpGuiaTallas(guideButton);

            let recomendationTitle = document.createElement("h3");
            recomendationTitle.innerText = "¿No estás seguro de tu talla?";
            buttonRecomendation.appendChild(recomendationTitle);
            let recomendationText = document.createElement("span");
            recomendationText.innerText =
                "Contáctanos y te ayudamos a elegir la talla correcta con nuestras recomendaciones.";
            buttonRecomendation.appendChild(recomendationText);

            const icon = document.createElement("i");
            icon.className =
                "material-symbols-outlined v-icon notranslate v-theme--light v-icon--size-default";
            icon.textContent = "add_circle";
            buttonRecomendation.appendChild(icon);
        }

        form.appendChild(mainDivOption);
    });

    if (tablaMedidas) {
        const tallasContainer = document.createElement("div");
        tallasContainer.className = "tallas-container";
        tallasContainer.style.marginBottom = "10px";

        const guiaButton = document.createElement("button");
        guiaButton.type = "button";
        guiaButton.dataset.productTitle = product.title;
        guiaButton.dataset.medidas = tablaMedidas;
        guiaButton.onclick = () => handleOpenPopUpGuiaMedidas(guiaButton);

        const icon = document.createElement("i");
        icon.className =
            "material-symbols-outlined v-icon notranslate v-theme--light v-icon--size-default";
        icon.textContent = "add_circle";
        guiaButton.appendChild(icon);

        const titleSpan = document.createElement("span");
        titleSpan.className = "tallas-content-title";
        titleSpan.textContent = "¿No sabes cómo elegir?";

        const textSpan = document.createElement("span");
        textSpan.className = "tallas-content-text";
        textSpan.innerHTML =
            "Te ayudamos a responder tus dudas en <b>WhatsApp</b>";

        const buttonTabla = document.createElement("button");
        buttonTabla.className = "sizes-btn-table";
        buttonTabla.innerText = "Tabla de medidas";
        buttonTabla.type = "button";
        buttonTabla.dataset.productTitle = product.title;
        buttonTabla.dataset.medidas = tablaMedidas;
        buttonTabla.onclick = () => handleOpenPopUpGuiaMedidas(buttonTabla);

        form.appendChild(tallasContainer);
    }

    // ✅ Botón agregar al carrito (solo una vez)
    const buttonAddToCart = document.createElement("button");
    const optionNames = options.map((opt) => opt.name.toLowerCase());
    const hasColorOption = optionNames.includes("color");
    const hasSizeOption =
        optionNames.includes("size") ||
        optionNames.includes("talla") ||
        optionNames.includes("tamaño");

    buttonAddToCart.type = "button";
    buttonAddToCart.classList.add("button-add-to-cart-pop-up");
    buttonAddToCart.disabled = true;

    if (hasColorOption && hasSizeOption)
        buttonAddToCart.textContent = "Selecciona un color y una talla";
    else if (hasColorOption)
        buttonAddToCart.textContent = "Selecciona un color";
    else if (hasSizeOption)
        buttonAddToCart.textContent = "Selecciona una talla";
    else buttonAddToCart.textContent = "Selecciona una variante";

    form.appendChild(buttonAddToCart);

    // ✅ Beneficios
    const benefitsDiv = document.createElement("div");
    benefitsDiv.classList.add("easy-checkout-benefits");

    const iconSpan = document.createElement("span");
    iconSpan.className = "material-symbols-outlined";
    iconSpan.textContent = "check_small";

    const textSpan = document.createElement("span");
    textSpan.textContent = hasSizeOption
        ? "Envío y cambio de talla gratis a todo México"
        : "Envío gratis a todo México a partir de $1,500 MXN";

    benefitsDiv.append(iconSpan, textSpan);
    form.appendChild(benefitsDiv);

    // ✅ Evento único del botón agregar al carrito
    buttonAddToCart.addEventListener("click", async () => {
        const selectedVariantId = Number(variantIdInput.value);
        if (!selectedVariantId)
            return alert("Selecciona primero color y talla");

        try {
            await fetch("/cart/add.js", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    items: [{ id: selectedVariantId, quantity: 1 }],
                }),
            });

            await updateMinicart();
            closePopUpEasyCheckout();
            openMinicart();
        } catch (error) {
            console.error("Error al agregar al carrito:", error);
        }
    });

    // ⚡ PRESELECCIÓN SEGURA DE COLOR Y TALLA
    const firstAvailableVariant = product.variants.find((v) => v.available);
    if (!preselectedColor && firstAvailableVariant)
        preselectedColor = firstAvailableVariant.option1;
    if (!preselectedSize && firstAvailableVariant)
        preselectedSize = firstAvailableVariant.option2;

    if (preselectedColor) {
        const colorButton = form.querySelector(
            `.color-square[data-color="${preselectedColor}"]`,
        );
        if (colorButton)
            colorButton.dispatchEvent(new Event("click", { bubbles: true }));
    }
    if (preselectedSize) {
        const sizeButton = form.querySelector(
            `.size-button[data-size="${preselectedSize}"]`,
        );
        if (sizeButton)
            sizeButton.dispatchEvent(new Event("click", { bubbles: true }));
    }

    return form;
}
